import { AuthRequest, Method } from 'src/util/Request';
import { baseUrl, genericNetworkErrorHandler } from '.';

export const getReports = async () => {
    const url = `${baseUrl}/reports`;
    const res = await AuthRequest(url, Method.GET);

    if (res.ok) {
        const reports = await res.json();
        return reports.data;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const getReportTokens = async (reportName: string) => {
    const url = `${baseUrl}/reports/${reportName}`;
    const res = await AuthRequest(url, Method.GET);

    if (res.ok) {
        const report = await res.json();
        return report.data;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const getOsdManifestReportPdf = async (dueDate: string, routeName: string) => {
    const url = `${baseUrl}/reports/fmtp/osd/${routeName}/${dueDate}`;
    const res = await AuthRequest(url, Method.GET);

    if (res.ok) {
        const report = await res.json();
        return report;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const getOsdManifestRoutes = async () => {
    const url = `${baseUrl}/reports/fmtp/osd/routes`;
    const res = await AuthRequest(url, Method.GET);

    if (res.ok) {
        const report = await res.json();
        return report;
    } else {
        await genericNetworkErrorHandler(res);
    }
};
